import { ref, watch } from 'vue'

const COLLAPSED_KEY = 'dozor_sidebar_collapsed'

function readCollapsed(): boolean {
  if (typeof localStorage === 'undefined') return false
  return localStorage.getItem(COLLAPSED_KEY) === '1'
}

const collapsed = ref<boolean>(readCollapsed())
const mobileDrawerOpen = ref<boolean>(false)

watch(
  collapsed,
  (v) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(COLLAPSED_KEY, v ? '1' : '0')
    }
  },
  { flush: 'sync' },
)

export function useSidebarState() {
  function toggleCollapsed() {
    collapsed.value = !collapsed.value
  }
  function openMobileDrawer() {
    mobileDrawerOpen.value = true
  }
  function closeMobileDrawer() {
    mobileDrawerOpen.value = false
  }
  return { collapsed, toggleCollapsed, mobileDrawerOpen, openMobileDrawer, closeMobileDrawer }
}
